import { useCookies } from '@vueuse/integrations/useCookies'

export function useCookieUtils() {
    return {
        listenCookieChange,
        getCookie,
        setCookie,
        clearCookie
    }
}

const cookiesComposable = useCookies(null, { autoUpdateDependencies: true })

function getCookie(cookieId: string) {
    return cookiesComposable.get(cookieId);
}

function clearCookie(cookieId: string) {
    return cookiesComposable.remove(cookieId);
}

function setCookie(cookieId: string, value: string, maxAge: number, sameSite: boolean | 'none' | 'lax' | 'strict') {
    cookiesComposable.set(cookieId, value, { maxAge, sameSite });
}

function listenCookieChange(cookieId: string, callback: any, interval = 1000) {
    let lastCookie = cookiesComposable.get(cookieId);
    const intervalId = setInterval(()=> {
        const cookie = cookiesComposable.get(cookieId);
        if (cookie !== lastCookie) {
            try {
                clearInterval(intervalId);
                callback();
            } finally {
                lastCookie = cookie;
            }
        }
    }, interval);
}